export var wrapper = function (alignment) {
    return "py-6 px-4 flex flex-col justify-evenly items-".concat(alignment);
};
export var textWrapper = function (alignment) { return "mb-2 text-".concat(alignment); };
export var button = 'mb-4 mt-4';
export var iconWrapper = function (color) {
    return "z-10 mb-3 rounded-full p-3 bg-".concat(color);
};
//# sourceMappingURL=action-modal.styles.js.map